import React from "react";
import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { commonStyles } from "../../Services/ReactPDFService.jsx";

// Creative Cover Letter Template - Bold Artistic Design with Gradient
const styles = StyleSheet.create({
  ...commonStyles,
  page: {
    ...commonStyles.page,
    fontFamily: "Roboto",
    backgroundColor: "#ffffff",
    padding: 0,
  },
  // Diagonal accent background
  topAccent: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    height: 180,
    backgroundColor: "#667eea",
  },
  // Diagonal decorative element
  diagonalShape: {
    position: "absolute",
    right: -50,
    top: 100,
    width: 200,
    height: 200,
    backgroundColor: "#764ba2",
    opacity: 0.3,
    transform: "rotate(45deg)",
  },
  headerContainer: {
    paddingTop: 50,
    paddingBottom: 40,
    paddingLeft: 50,
    paddingRight: 50,
    position: "relative",
  },
  contentContainer: {
    padding: "30 50 50 50",
  },
  name: {
    fontSize: 28,
    fontWeight: 700,
    color: "#ffffff",
    marginBottom: 12,
    letterSpacing: 1,
    textTransform: "uppercase",
  },
  contactInfoWhite: {
    fontSize: 11,
    color: "#f0f0f0",
    marginBottom: 4,
  },
  decorativeLine: {
    width: 80,
    height: 4,
    backgroundColor: "#ffffff",
    marginTop: 12,
    marginBottom: 15,
  },
  bodyText: {
    fontSize: 11,
    lineHeight: 1.7,
    color: "#2d3748",
    marginBottom: 12,
    textAlign: "justify",
  },
});

const CreativeCoverLetter = ({ coverLetterData }) => {
  const { header, generatedContent } = coverLetterData || {};
  const { name, email, phone, location } = header || {};

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Background Accents */}
        <View style={styles.topAccent} />
        <View style={styles.diagonalShape} />

        {/* Creative Header */}
        <View style={styles.headerContainer}>
          <Text style={styles.name}>{name || "[Name]"}</Text>
          <View style={styles.decorativeLine} />
          <Text style={styles.contactInfoWhite}>
            {email || "[Email]"} • {phone || "[Phone]"}
          </Text>
          <Text style={styles.contactInfoWhite}>{location || "[Location]"}</Text>
        </View>

        {/* Body Content */}
        <View style={styles.contentContainer}>
          <Text style={styles.bodyText}>{generatedContent || "No content generated yet."}</Text>
        </View>
      </Page>
    </Document>
  );
};

export default CreativeCoverLetter;
